// extracted by mini-css-extract-plugin
export default {"button":"UpButton_button__33BGR","flareAnimation":"UpButton_flareAnimation__rLwL4"};